import React, { forwardRef, useRef, useState } from 'react';
import HTMLFlipBook from 'react-pageflip';

import transfer1 from '../assets/image/transfer-1.png';
import Group105 from '../assets/image/Group-105.png';
import Trading1 from '../assets/image/Trading-1.png';
import one from '../assets/image/booklet/booklet 27-05-2025 change UFCP_page-0001.jpg'
import two from '../assets/image/booklet/booklet 27-05-2025 change UFCP_page-0002.jpg'
import three from '../assets/image/booklet/booklet 27-05-2025 change UFCP_page-0003.jpg'
import four from '../assets/image/booklet/booklet 27-05-2025 change UFCP_page-0004.jpg'
import five from '../assets/image/booklet/booklet 27-05-2025 change UFCP_page-0005.jpg'
import six from '../assets/image/booklet/booklet 27-05-2025 change UFCP_page-0006.jpg'
import seven from '../assets/image/booklet/booklet 27-05-2025 change UFCP_page-0007.jpg'
import eight from '../assets/image/booklet/booklet 27-05-2025 change UFCP_page-0008.jpg'
import nine from '../assets/image/booklet/booklet 27-05-2025 change UFCP_page-0009.jpg'
import ten from '../assets/image/booklet/booklet 27-05-2025 change UFCP_page-0010.jpg'
import eleven from '../assets/image/booklet/booklet 27-05-2025 change UFCP_page-0011.jpg'
import twelve from '../assets/image/booklet/booklet 27-05-2025 change UFCP_page-0012.jpg'
import thiretten from '../assets/image/booklet/booklet 27-05-2025 change UFCP_page-0013.jpg'
import fourteen from '../assets/image/booklet/booklet 27-05-2025 change UFCP_page-0014.jpg'
import fifeteen from '../assets/image/booklet/booklet 27-05-2025 change UFCP_page-0015.jpg'
import sixteen from '../assets/image/booklet/booklet 27-05-2025 change UFCP_page-0016.jpg'
import seventeen from '../assets/image/booklet/booklet 27-05-2025 change UFCP_page-0017.jpg'
import eightteen from '../assets/image/booklet/booklet 27-05-2025 change UFCP_page-0018.jpg'
import nineteen from '../assets/image/booklet/booklet 27-05-2025 change UFCP_page-0019.jpg'
// import twenty from '../assets/image/booklet/booklet 27-05-2025 change UFCP_page-0020.jpg'
// import twentyone from '../assets/image/booklet/booklet 27-05-2025 change UFCP_page-0021.jpg'
// import twentytwo from '../assets/image/booklet/booklet 27-05-2025 change UFCP_page-0022.jpg'
import render12 from '../assets/image/RENDER-1-copy.webp';
import booklet from "../assets/image/booklet.pdf"
import { GoDownload } from "react-icons/go";




function Booklist(props) {

    const bookRef = useRef(null);
    const [currentPage, setCurrentPage] = useState(0); // 0-based index

    const totalPages = 19;

    const nextPage = () => {

        if (bookRef.current && bookRef.current.pageFlip()) {
            bookRef.current.pageFlip().flipNext();
        }

    };

    const prevPage = () => {

        if (bookRef.current && bookRef.current.pageFlip()) {
            bookRef.current.pageFlip().flipPrev();
        }

    };

    const handleFlip = (e) => {
        setCurrentPage(e.data); // e.data is the current page index
    };



    return (

        <div className='App'>
            <div className='mt-3 mb-5'>
                <div className='book-list'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-lg-12'>
                                <div className="row justify-content-center align-items-center m-0">
                                    <div className="col-lg-12 ">
                                        <div className="pt-4 d-flex justify-content-between">
                                            <a class="navbar-brand" href="/"><img src={render12}></img></a>
                                            <a href={booklet} className="book-dolwnload" download title="Download Booklet">
                                                <GoDownload style={{ color: "#BC9018 ", fontSize: "30px" }} />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className='inside-book' style={{ position: 'relative', width: '100%', display: 'flex', justifyContent: 'center' }}>
                                    <div className='spiral' style={{
                                        position: 'absolute',
                                        width: '12px',
                                        height: '600px',
                                        top: 0,
                                        zIndex: 10,
                                        background: 'repeating-linear-gradient(black 0 2px, transparent 2px 8px)',
                                        left: '50%',
                                        transform: 'translateX(-50%)'
                                    }} />
                                    <HTMLFlipBook
                                        width={1000}   // 2 x 500 (for double pages)
                                        height={1000}
                                        size="stretch"
                                        minWidth={500}
                                        maxWidth={1000}
                                        minHeight={600}
                                        maxHeight={600}
                                        maxShadowOpacity={0.5}
                                        showCover={false}
                                        mobileScrollSupport={true}
                                        ref={bookRef}
                                        onFlip={handleFlip}
                                    >

                                        <div number="1"><img src={one} style={{ width: "100%", height: "100%" }} /></div>
                                        <div number="2"><img src={two} style={{ width: "100%", height: "100%" }} /></div>
                                        <div number="3"><img src={three} style={{ width: "100%", height: "100%" }} /></div>
                                        <div number="4"><img src={four} style={{ width: "100%", height: "100%" }} /></div>
                                        <div number="5"><img src={five} style={{ width: "100%", height: "100%" }} /></div>
                                        <div number="6"><img src={six} style={{ width: "100%", height: "100%" }} /></div>
                                        <div number="7"><img src={seven} style={{ width: "100%", height: "100%" }} /></div>
                                        <div number="8"><img src={eight} style={{ width: "100%", height: "100%" }} /></div>
                                        <div number="9"><img src={nine} style={{ width: "100%", height: "100%" }} /></div>
                                        <div number="10"><img src={ten} style={{ width: "100%", height: "100%" }} /></div>
                                        <div number="11"><img src={eleven} style={{ width: "100%", height: "100%" }} /></div>
                                        <div number="12"><img src={twelve} style={{ width: "100%", height: "100%" }} /></div>
                                        <div number="13"><img src={thiretten} style={{ width: "100%", height: "100%" }} /></div>
                                        <div number="14"><img src={fourteen} style={{ width: "100%", height: "100%" }} /></div>
                                        <div number="15"><img src={fifeteen} style={{ width: "100%", height: "100%" }} /></div>
                                        <div number="16"><img src={sixteen} style={{ width: "100%", height: "100%" }} /></div>
                                        <div number="17"><img src={seventeen} style={{ width: "100%", height: "100%" }} /></div>
                                        <div number="18"><img src={eightteen} style={{ width: "100%", height: "100%" }} /></div>
                                        <div number="19"><img src={nineteen} style={{ width: "100%", height: "100%" }} /></div>
                                        {/* <div number="20"><img src={twenty} style={{ width: "100%", height: "100%" }} /></div>
                                        <div number="21"><img src={twentyone} style={{ width: "100%", height: "100%" }} /></div>
                                        <div number="22"><img src={twentytwo} style={{ width: "100%", height: "100%" }} /></div> */}


                                    </HTMLFlipBook>


                                </div>
                                <div style={{ marginTop: '20px', display: 'flex', gap: '10px', justifyContent: "center", alignItems: 'center' }}>
                                    <button className='treasure-btn-2 active' onClick={prevPage}>Pre</button>
                                    <p className='mb-0'>({currentPage + 1} of {totalPages})</p>
                                    <button className='treasure-btn-2 active' onClick={nextPage}>Next</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default Booklist;
